import { API } from "../lib/api";

const initials = (n = "") => n.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "?";

export const UserAvatar = ({ user, size = "w-9 h-9 text-sm", testid }) =>
  user?.photo_v ? (
    <img src={`${API}/users/${user.id}/photo?v=${encodeURIComponent(user.photo_v)}`} alt={user.name}
      className={`${size} rounded-full object-cover border border-slate-200 shrink-0`} data-testid={testid} />
  ) : (
    <span className={`${size} rounded-full bg-[#0F172A] text-white font-bold grid place-items-center shrink-0`} data-testid={testid}>
      {initials(user?.name)}
    </span>
  );

export const roleLabel = (t, role) => ({ owner: t("Owner", "Dueño"), office: t("Office", "Oficina"), crew: t("Crew", "Equipo de campo") }[role] || role);
